import React from 'react';
import { useTranslation } from 'react-i18next';
import SuccessMessage from '../../SuccessMessage';

type FormResult = {
  success: boolean,
  message?: string,
};

type Step2ResultProps = {
  formResult: FormResult,
  onNext: () => void,
  onRestart: () => void,
  onDownloadExcel?: () => void,
  hasExcelDownload?: boolean,
};

function Step2Result( {
  formResult,
  onNext,
  onRestart,
  onDownloadExcel,
  hasExcelDownload,
}: Step2ResultProps ) {
  const { t } = useTranslation();

  return (
    <SuccessMessage
      success={formResult.success}
      description={formResult.success ? t( 'admin.processes.fileDownloaded' ) : ( formResult.message ?? '' )}
      primaryButtonLabel={formResult.success ? t( 'admin.processes.next' ) : undefined}
      onPrimaryClick={onNext}
      onRestart={onRestart}
      secondaryButtonLabel={formResult.success && hasExcelDownload ? t( 'admin.processes.downloadExcel' ) : undefined}
      onSecondaryClick={formResult.success && hasExcelDownload ? onDownloadExcel : undefined}
    />
  );
}

export default Step2Result;
